module.exports = __webpack_public_path__ + "bf09f59efbc4e23e9d56b7977aaca842.pdf";